import { getPeriodTypeFromId } from "../../period/PeriodType.js";
import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * Wraps another node to compute it in a rolling period.
 * For example, a "rolling period" for 6 Quarters will compute the sum of the last 6 Quarters values.
 *
 * @param {int} rollingLength - Length of the rolling interval
 * @param {PeriodType} periodType - Type of period used to compute the rolling period value
 */
export default class PeriodRollingFormulaNode extends WrapperFormulaNode {
	constructor({ rollingLength = 2, periodType }) {
		super(...arguments);
		this._rollingLength = rollingLength;
		this._periodType = periodType;
	}

	getRollingLength() {
		return this._rollingLength;
	}

	getPeriodType() {
		return this._periodType;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitPeriodRollingFormulaNode(
			this,
			additionalInformation,
		);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();
		properties.rollingLength = this._rollingLength;
		properties.periodType = this._periodType?.getId();

		return properties;
	}

	static getType() {
		return "PeriodRollingNode";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);
		data.periodType = getPeriodTypeFromId(data.periodType);
	}
}
